import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { ButtonGroup, Button, Typography, } from "@mui/material";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import { VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
export var handleOnCopy = function (value) {
    if (value && typeof value === "string") {
        navigator.clipboard.writeText(value);
    }
};
var CopyPasswordButton = function (_a) {
    var label = _a.label, value = _a.value, children = _a.children, _b = _a.IconProps, IconProps = _b === void 0 ? {} : _b, _c = _a.copiedText, copiedText = _c === void 0 ? "Password copied!" : _c, props = __rest(_a, ["label", "value", "children", "IconProps", "copiedText"]);
    var _d = useState(false), copied = _d[0], setCopied = _d[1];
    var _e = useState(false), showPassword = _e[0], setShowPassword = _e[1];
    var handleShowPassword = function (e) {
        e.preventDefault();
        setShowPassword(function (show) { return !show; });
    };
    useEffect(function () {
        if (copied) {
            setTimeout(function () {
                setCopied(false);
            }, 1000);
        }
    }, [copied]);
    return (_jsxs(ButtonGroup, { children: [_jsx(Button, __assign({ "data-testid": "".concat(label, "-Copy-Button"), className: "Password-Copy-Button", onClick: function () {
                    handleOnCopy(value);
                    setCopied(true);
                }, fullWidth: true, endIcon: copied ? (_jsx(CheckCircleOutlineOutlinedIcon, __assign({ fontSize: "small" }, IconProps))) : (_jsx(ContentCopyOutlinedIcon, __assign({ fontSize: "small" }, IconProps))), sx: {
                    paddingLeft: "0",
                    paddingRight: "0",
                } }, props, (copied && {
                color: "success",
            }), { children: _jsx(Typography, { variant: "body2", sx: {
                        width: "calc(100% - 60px)",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                    }, children: copied ? copiedText : showPassword ? children : "************" }) })), _jsx(Button, __assign({}, props, (copied && {
                color: "success",
            }), { children: showPassword ? (_jsx(VisibilityOffOutlined, __assign({ fontSize: "small" }, IconProps, { onClick: handleShowPassword }))) : (_jsx(VisibilityOutlined, __assign({ fontSize: "small" }, IconProps, { onClick: handleShowPassword }))) }))] }));
};
export default CopyPasswordButton;
